import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + "/v1/";

const axiosConfig = {
    headers: {
        "Content-Type": "application/json;charset=UTF-8",
    }
};

const validateToken = (token) => {
    return axios.get(API_URL + "reset-password/validate?token=" + token, axiosConfig);
};

const resetPassword = (token, newPassword) => {
    return axios.post(API_URL + "reset-password", { token, newPassword }, axiosConfig);
};

const requestPasswordReset = (username) => {
    return axios.post(API_URL + "forgot-password", { username }, axiosConfig);
};

const passwordResetService = {
    validateToken,
    resetPassword,
    requestPasswordReset
};

export default passwordResetService;
